import { render, staticRenderFns } from "./itemRecipeBox.vue?vue&type=template&id=7d0ca420&"
import script from "./itemRecipeBox.vue?vue&type=script&lang=ts&"
export * from "./itemRecipeBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports